import FeePaymantConfiguration from './FeePaymentConfiguration';

export default FeePaymantConfiguration;
